/** 
 * Search
 */
$(document).on("ready", function () { 
    // Search results
    // Restore Study Type focus and position after filtering.
    function restoreStudyTypeFocus() {
        var key = "fw-study-type:" + window.location.pathname;
        var saved;

        try {
            saved = sessionStorage.getItem(key);
            sessionStorage.removeItem(key);
        } catch (error) {
            return;
        }

        if (!saved) {
            return;
        }

        try {
            var state = JSON.parse(saved);
            var radio = document.getElementById(state.id);

            if (
                !radio ||
                !radio.matches('input[type="radio"][name="StudyType"]') ||
                !radio.checked
            ) {
                return;
            }

            window.requestAnimationFrame(function () {
                radio.focus({ preventScroll: true });
                window.scrollTo(state.x, state.y);
            });
        } catch (error) {
            // Ignore an unavailable or invalid saved focus state.
        }
    }

    if (document.readyState === "complete") {
        restoreStudyTypeFocus();
    } else {
        $(window).one("pageshow", restoreStudyTypeFocus);
    }

    /**
     * Keeps accordion state available to keyboard and screen-reader users
     * while preserving the existing accordion markup and CSS classes.
     */
    $(".accordionCtrl").each(function () {
        var $control = $(this);
        var $accordion = $control.parent(".accordion");
        var labelText = $.trim(
            $accordion.children("fieldset").find("legend").first().text() ||
            $accordion.children("label").first().text() ||
            "section"
        );

        $control.attr("aria-label", "Toggle " + labelText);
        $control.attr("aria-expanded", !$accordion.hasClass("closed"));
    });

    $(".accordionCtrl").on("click", function () { 
        var $accordion = $(this).parent(".accordion");

        $accordion.toggleClass("closed");
        $(this).attr("aria-expanded", !$accordion.hasClass("closed"));
    });

    $(".accordionCtrl").on("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            $(this).trigger("click");
        }
    });

    /**
     * Maintains the visual state and accessible expanded state of detail sections.
     */
    $(".seeMore").on("click", function (e) {
        e.preventDefault();

        var $container = $(this);
        var $detailSection = $container.prev(".detailSection");
        var $button = $container.find(".seeMoreButton");

        $detailSection.toggleClass("opened");

        var isOpen = $detailSection.hasClass("opened");

        $button.attr("aria-expanded", isOpen);

        if (isOpen) {
            $button.html("<span>-</span> LESS");
            $button.attr("aria-label", "Show less details");
        } else {
            $button.html("<span>+</span> MORE");
            $button.attr("aria-label", "Show more details");
        }
    });

    /**
     * Gives existing filter chips keyboard semantics without changing
     * their visual markup or CSS classes.
     */
    $(".filter").each(function () {
        var filterName = $.trim(
            $(this).clone().children("span").remove().end().text()
        );

        $(this)
            .attr("role", "button")
            .attr("tabindex", "0")
            .attr(
                "aria-label",
                $(this).attr("id") === "clearAll"
                    ? "Clear all filters"
                    : "Remove filter " + filterName
            );
    });

    $(".filter").on("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            $(this).trigger("click");
        }
    });

    $(".filter").on("click", function () { 
        var which = $(this).attr("data-which"); 

        if ($(this).attr("id") === "clearAll") { 
            $("#search input, #search select").val(""); 
        } else if ($(this).attr("data-which") === "Military") { 
            $("#military0").prop("checked", true); 
        } else if ($(this).attr("data-which") == "Disability") { 
            $("#disability0").prop("checked", true); 
        } else if ($(this).attr("data-which") == "StudentType") { 
            $("#hs0").prop("checked", true); 
        } else if ($(this).attr("data-which") == "StudyType") { 
            $("#studytype0").prop("checked", true); 
        } else if ($(this).attr("data-which") == "ControlType") { 
            $("#controlType0").prop("checked", true); 
        } else if ($(this).attr("data-which") == "ProfitStatus") { 
            $("#profitStatus0").prop("checked", true); 
        } else if ($(this).hasClass("internship")) { 
            $("#" + which).prop("checked", false); 

            $("#internship-category").val( 
                $.map($(".internship-category:checked"), function (n, i) { 
                    return n.value; 
                }).join(",") 
            ); 
        } else { 
            // Targets the filter control associated with the selected filter.
            var $target = $("#" + which); 

            // Clears the selected filter value or checkbox state.
            $target.val("").prop("checked", false); 

            // Clears state selections associated with a removed region filter.
            $target.closest(".sub").find(".newstate").prop("checked", false); 

            // Supports filters that identify their associated control through data-filter.
            $('input[data-filter="' + which + '"]').prop("checked", false); 
        } 

        $("#search").append(
            '<input type="hidden" name="search" value="search" />'
        ); 

        $("#search").submit(); 
    });

    /**
     * Controls availability of the custom school-size range fields.
     */
    function handleSchoolSizeState() {
        var $checkbox = $("#schoolsizecustom");
        var $minInput = $("#SizeMin");
        var $maxInput = $("#SizeMax");
        var isChecked = $checkbox.prop("checked");

        $minInput.prop("disabled", !isChecked);
        $maxInput.prop("disabled", !isChecked);

        if (!isChecked) {
            $minInput.val("");
            $maxInput.val("");
        }
    }

    // Establishes the custom school-size field state when the page loads.
    handleSchoolSizeState();

    /**
     * Maintains the custom range fields when the custom-size option changes.
     */
    $(document).on("change", "#schoolsizecustom", function () {
        handleSchoolSizeState();

        if (!$(this).prop("checked")) {
            $("#search").submit();
        }
    });

    $(document).on(
        "change",
        "#search input, #search select, #browseSA #StudyCat",
        function () { 
        // Remember Study Type focus and position before filtering.
        if ($(this).is('input[type="radio"][name="StudyType"]')) {
            try {
                sessionStorage.setItem(
                    "fw-study-type:" + window.location.pathname,
                    JSON.stringify({
                        id: this.id,
                        x: window.scrollX,
                        y: window.scrollY
                    })
                );
            } catch (error) {
                // Filtering remains available when browser storage is unavailable.
            }
        }

            // Custom school size uses its own change behavior.
            if ($(this).attr("id") === "schoolsizecustom") {
                return; 
            }

            // Submits the custom range when at least one boundary contains a value.
            if (
                $(this).attr("id") === "SizeMin" ||
                $(this).attr("id") === "SizeMax"
            ) {
                if (
                    $("#SizeMin").val() !== "" ||
                    $("#SizeMax").val() !== ""
                ) {
                    $("#search").submit();
                }

                return;
            }

            if ($(this).val() == "custom") { 
                return; 
            } else if ($(this).attr("id") == "StudyCat") { 
                $.ajax({ 
                    type: "POST", 
                    url: "/wp-admin/admin-ajax.php", 
                    data: { 
                        action: "fw_study_areas_ajax", 
                        cat: $(this).val()
                    },

                    // Loads the available study areas for the selected category.
                    success: function (data) { 
                        $("#StudyFocus").html(data); 
                        $("#StudyArea0").select2(); 
                    },

                    error: function () {}
                }); 

                return; 
            } else if ($(this).hasClass("internship-category")) { 
                $("#internship-category").val( 
                    $.map(
                        $(".internship-category:checked"),
                        function (n, i) { 
                            return n.value; 
                        }
                    ).join(",") 
                ); 
            } 

            /**
             * Keeps region and individual state selections synchronized.
             */
            if ($(this).hasClass("newstate")) { 
                var $sub = $(this).closest(".sub"); 
                var $region = $sub.find(".lh input"); 
                var total = $sub.find(".newstate").length; 
                var checked = $sub.find(".newstate:checked").length; 

                // A region is selected when all states in that region are selected.
                $region.prop("checked", total === checked); 
            } else if ($(this).parent().hasClass("lh")) { 
                var isChecked = $(this).prop("checked"); 

                // Selecting a region applies the same state to all of its states.
                $(this)
                    .closest(".sub")
                    .find(".newstate")
                    .prop("checked", isChecked); 
            } 

            $("#search").submit(); 
        }
    ); 

    $("#cancelSearch").on("click", function () { 
        $("#keywords").val(""); 
    }); 

    $("#cancelNameSearch").on("click", function () { 
        $("#Name").val(""); 
    }); 

    /**
     * Supports Enter and Space activation for inline clear controls.
     */
    $("#cancelSearch, #cancelNameSearch").on(
        "keydown",
        function (e) {
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                $(this).trigger("click");
            }
        }
    );

    $("#pagination .page").on("click", function (e) { 
        e.preventDefault(); 

        var startRow =
            ($(this).text() - 1) *
            $("#Row_Count").val(); 

        $("#Page").val(startRow + 1); 
        $("#search").submit(); 
    }); 

    $("#pageForward").on("click", function (e) { 
        e.preventDefault(); 

        if (
            document
                .querySelector("#pageForward")
                .classList
                .contains("active")
        ) { 
            var startRow =
                $(".current.page").text() *
                $("#Row_Count").val(); 

            $("#Page").val(startRow + 1); 
            $("#search").submit(); 
        } 
    }); 

    $("#pageBack").on("click", function (e) { 
        e.preventDefault(); 

        if (
            document
                .querySelector("#pageBack")
                .classList
                .contains("active")
        ) { 
            var startRow =
                ($(".current.page").text() - 2) *
                $("#Row_Count").val(); 

            $("#Page").val(startRow + 1); 
            $("#search").submit(); 
        } 
    }); 

    $(".Row_Count").on("click", function (e) { 
        e.preventDefault(); 

        $("#Row_Count").val($(this).text()); 
        $("#search").submit(); 
    }); 

    /**
     * Supports keyboard activation for pagination and results-per-page controls.
     */
    $("#pageBack, #pageForward, .Row_Count").on(
        "keydown",
        function (e) {
            if (
                (e.key === "Enter" || e.key === " ") &&
                $(this).attr("aria-disabled") !== "true"
            ) {
                e.preventDefault();
                $(this).trigger("click");
            }
        }
    );

    /**
     * Selecting a custom school-size field also selects its associated checkbox.
     */
    $(document).on("focus", ".schoolSize input", function () { 
        $(".schoolSize")
            .parent("div")
            .children("input[type=checkbox]")
            .prop("checked", true); 
    }); 

    $(".noDetail").on("click", function (e) { 
        e.preventDefault(); 

        var $details = $(this).closest(".details"); 

        $details.find(".noDetailsP").remove(); 

        $details.append(
            '<p class="noDetailsP">' +
                "No further information is available for this school." +
            "</p>"
        ); 
    }); 

    /**
     * Maintains the mobile search-filter visibility and expanded state.
     */
    $("#slideOpen").on("click", function () { 
        $("aside").toggleClass("open");

        $(this).attr(
            "aria-expanded",
            $("aside").hasClass("open")
        );
    });

    $("#slideOpen").on("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            $(this).trigger("click");
        }
    });

    /**
     * Handles saved-search loading and saving.
     */
    $("#saveCurSearch, #loadCurSearch").on("click", function (e) { 
        e.preventDefault(); 

        var loc = window.location.pathname; 

        $.ajax({ 
            type: "POST", 
            url: "/wp-admin/admin-ajax.php", 
            data: { 
                action: "fw_getLoadSearch", 
                ValueType: $(this).data("which"), 
                which: $(this).data("which"), 
                loc: $(this).data("search"), 
                do_action: $(this).data("action")
            }, 
            dataType: "html", 

            success: function (data) { 
                addOverlay("loadSearchOL", data); 

                $("#submitSearchSave").on("click", function (e) { 
                    if ($("input[name=ValueName]").val() == "") { 
                        alert("Please enter a name."); 
                        return false; 
                    } 

                    $.ajax({ 
                        type: "POST", 
                        url: "/wp-admin/admin-ajax.php", 
                        data:
                            "action=fw_saveSearch_ajax&" +
                            $(this).closest("form").serialize(), 
                        dataType: "html", 

                        success: function (data) { 
                            $("#olContent").html(
                                '<p class="success">' +
                                    "Your search has been saved." +
                                "</p>"
                            ); 

                            setTimeout(function () { 
                                $("#overlay").remove(); 
                            }, 2000); 

                            window.location.reload(); 
                        }, 

                        error: function (xhr, desc, err) { 
                            console.log(xhr); 
                            console.log(
                                "Details0: " +
                                desc +
                                "\nError:" +
                                err
                            ); 
                        }
                    }); 
                }); 

                $(".deleteSearch").on("click", function (e) { 
                    e.preventDefault(); 

                    var p = $(this).parent("p"); 

                    $.ajax({ 
                        type: "POST", 
                        url: "/wp-admin/admin-ajax.php", 
                        data: { 
                            action: "fw_saveSearch_ajax", 
                            id: $(this).data("id"), 
                            do_action: "delete"
                        }, 
                        dataType: "html", 

                        success: function (data) { 
                            window.location.reload(); 
                            p.remove(); 
                        }, 

                        error: function (xhr, desc, err) { 
                            console.log(xhr); 
                            console.log(
                                "Details0: " +
                                desc +
                                "\nError:" +
                                err
                            ); 
                        }
                    }); 
                }); 

                $("#cancelSearchSave").on(
                    "click",
                    function (e) { 
                        e.preventDefault(); 
                        $("#overlay").remove(); 
                    }
                ); 
            }, 

            error: function (xhr, desc, err) { 
                console.log(xhr); 
                console.log(
                    "Details0: " +
                    desc +
                    "\nError:" +
                    err
                ); 
            }
        }); 
    }); 
});